module.exports = __webpack_public_path__ + "img/icon_pay_02.1345e31f.svg";